import { Component, Injector, OnInit } from '@angular/core';
import { LoaderService } from '@app/main/cablepro/loader.service';
import { Title } from '@node_modules/@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@node_modules/@angular/router';
import { filter, map } from '@node_modules/rxjs/operators';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { MomentHelper } from '@shared/helpers/MomentHelper';
import { CompanyAccountService } from '@shared/service-proxies/company-account.service';
import { SubscriptionServiceProxy, UserLoginInfoDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-webfacing',
  templateUrl: './webfacing.component.html',
  styleUrls: ['./webfacing.component.css'],
})
export class WebfacingComponent extends AppComponentBase implements OnInit {

  public user!: UserLoginInfoDto | undefined;
  public calculationStandard: number = 0;
  public isAdminUser: boolean = false;
  public unRegisteredUser: boolean = false;
  public hasPlanExpired: boolean = false;
  private planDueDays: number = 0;
  constructor(injector: Injector, private _router: Router,
    private titleService: Title,
    private route: ActivatedRoute,
    public _appSessionService: AppSessionService,
    private _companyAccountService: CompanyAccountService,
    public loaderService: LoaderService,
    private _subscriptionService: SubscriptionServiceProxy) {
    super(injector);
  }

  public blockUI: boolean = false;
  ngOnInit(): void {
    this.loaderService.blockUI$.subscribe(block => {
      if (block) {
        this.blockUI = true;
        // hide, disable, or stop rendering
      }
    });
    // Handle initial load
    this.setTitle(this.route);

    // Handle title updates on navigation
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.route),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        map(route => route.snapshot.data['title'])
      )
      .subscribe(title => {
        if (title) {
          this.titleService.setTitle(`${title}`);
        }
      });

    this.user = this._appSessionService.user;
    if (!(this._router.url.indexOf('/pricing') > -1)) {
      if (this.user && !this.user.isWebFacingUser) {
        this.isAdminUser = (this.user.id === 1 || this.user.id === 2);
        this.hasPlanExpired = this._appSessionService.user.premiumUser && MomentHelper.IsSubscriptionDateExpired(this.user.expirationDate);
        this.planDueDays = MomentHelper.GetSubscriptionDueDays(this.user.expirationDate);
        this.unRegisteredUser = false;

        if (this.user.userStripeCustomerId === null || this.user.userStripeCustomerId === undefined) {
          this.unRegisteredUser = true;
        }
        else if (this.user.userStripeCustomerId.trim().length == 0 || this.user.userStripeCustomerId.trim() == '0') {
          this.unRegisteredUser = true;
        }
        this.calculationStandard = this.user.userSetting.standards_CableSizing || 0;
        if (this.user.periodEndDate != null && this.user.periodEndDate != undefined
          && this.user.periodEndDate == "Inactive") {
          this.loaderService.setBlockUI(true);
          this.handleUnlicencesOrExpiredFlow(this.user, this.calculationStandard, this._companyAccountService, this._router);
        }
        else {
          if (this.user.periodEndDate != null && this.user.periodEndDate != undefined
            && this.user.periodEndDate != "succeeded") {
            this.loaderService.setBlockUI(true);
            this.handleFailedOrUnpaidFlow(this.user, this.loaderService, this._subscriptionService, this._companyAccountService, this._router);
          }
        }

        if (!this.isAdminUser) {
          if (this.unRegisteredUser && (this.hasPlanExpired || (this.planDueDays >= -7 && this.planDueDays <= 0))) {
            if (this._appSessionService.user.premiumUser && this.hasPlanExpired) {
              this.loaderService.setBlockUI(true);
              this.handleUnlicencesOrExpiredFlow(this.user, this.calculationStandard, this._companyAccountService, this._router);
            }
          }
        }
      }
    }
  }

  private setTitle(route: ActivatedRoute): void {
    let currentRoute = route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    const title = currentRoute.snapshot.data['title'];
    if (title) {
      this.titleService.setTitle(`${title}`);
    }
  }

}
